// src/admin/components/AdminSidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { RxDashboard } from 'react-icons/rx';
import { TfiAnnouncement } from "react-icons/tfi";
import { HiOutlineUsers } from "react-icons/hi2";
import { TfiLayoutSlider } from "react-icons/tfi";
import { FaImages, FaBookOpen, FaFileAlt, FaPhotoVideo, FaBuilding, FaChalkboardTeacher, FaTrophy, FaUserGraduate, FaHome } from "react-icons/fa"; // FaHome Added
import { IoClose } from "react-icons/io5";
import { FaBriefcase } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { FaPenNib } from "react-icons/fa";
import { FaUserPlus } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaCommentDots } from 'react-icons/fa';
import { FaPalette } from "react-icons/fa";

const AdminSidebar = ({ isSidebarOpen, setSidebarOpen }) => {
    const linkClasses = "flex items-center p-3 my-1 text-gray-700 rounded-lg hover:bg-orange-100 hover:text-orange-600 transition-colors duration-200";
    const activeLinkClasses = "bg-orange-500 text-white hover:bg-orange-600 hover:text-white";

    return (
        <>
            {/* Overlay for mobile */}
            <div 
                className={`fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden ${isSidebarOpen ? 'block' : 'hidden'}`}
                onClick={() => setSidebarOpen(false)}
            ></div>

            <aside className={`fixed md:relative inset-y-0 left-0 bg-white shadow-xl w-64 transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 transition-transform duration-300 ease-in-out z-40`}>
                <div className="p-4 flex justify-between items-center border-b">
                    <h1 className="text-2xl font-bold text-orange-500">J&J Admin</h1>
                    <button onClick={() => setSidebarOpen(false)} className="md:hidden text-gray-600 hover:text-gray-900">
                        <IoClose size={24} />
                    </button>
                </div>
                
                {/* Scrollable Navigation Area */}
                <nav className="p-4 h-[calc(100vh-70px)] overflow-y-auto">
                    <NavLink 
                        to="/admin/dashboard"
                        className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}
                    >
                        <RxDashboard className="mr-3" size={20} />
                        Dashboard
                    </NavLink>
                    <NavLink 
                        to="/admin/manage-announcements"
                        className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}
                    >
                        <TfiAnnouncement className="mr-3" size={20} />
                        Announcements
                    </NavLink>
                    <NavLink 
                        to="/admin/manage-leadership"
                        className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}
                    >
                        <HiOutlineUsers className="mr-3" size={20} />
                        Leadership
                    </NavLink>
                    <NavLink 
                        to="/admin/manage-testimonials"
                        className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}
                    >
                        <HiOutlineUsers className="mr-3" size={20} />
                        Testimonials
                    </NavLink>
                    <NavLink 
                        to="/admin/manage-hero-slides"
                        className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}
                    >
                        <TfiLayoutSlider className="mr-3" size={20} />
                        Hero Slider
                    </NavLink>
                    <NavLink 
                        to="/admin/manage-gallery"
                        className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}
                    >
                        <FaImages className="mr-3" size={20} />
                        Gallery
                    </NavLink>
                    <NavLink 
                        to="/admin/manage-board-results"
                        className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}
                    >
                        <FaTrophy className="mr-3" size={20} />
                        Board Results
                    </NavLink>
                    <NavLink 
                        to="/admin/manage-book-lists"
                        className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}
                    >
                        <FaBookOpen className="mr-3" size={20} />
                        Book Lists
                    </NavLink>
                    <NavLink 
                        to="/admin/manage-site-content"
                        className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}
                    >
                        <FaFileAlt className="mr-3" size={20} />
                        Site Content
                    </NavLink>
                    <NavLink 
                        to="/admin/manage-site-images"
                        className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}
                    >
                        <FaPhotoVideo className="mr-3" size={20} />
                        Site Images
                    </NavLink>
                    <NavLink 
                        to="/admin/manage-campus-facilities"
                        className={({ isActive }) => `${isActive ? activeLinkClasses : ''} ${linkClasses}`}
                    >
                        <FaBuilding className="mr-3" size={20} />
                        Campus Facilities
                    </NavLink>
                    
                    <NavLink 
                        to="/admin/manage-faculty"
                        className={({ isActive }) => `${isActive ? activeLinkClasses : ''} ${linkClasses}`}
                    >
                        <FaChalkboardTeacher className="mr-3" size={20} />
                        Faculty
                    </NavLink>
                    <NavLink to="/admin/manage-alumni" className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}>
                        <FaUserGraduate className="mr-3" size={20} /> Alumni Network
                    </NavLink>
                    <NavLink to="/admin/manage-careers" className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}>
                        <FaBriefcase className="mr-3" size={20} /> Careers
                    </NavLink>
                    <NavLink to="/admin/manage-contact" className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}>
                        <FaPhoneAlt className="mr-3" size={20} /> Contact & Inquiries
                    </NavLink>
                    <NavLink to="/admin/manage-blogs" className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}>
                        <FaPenNib className="mr-3" size={20} /> Blogs
                    </NavLink>
                    <NavLink to="/admin/manage-admissions" className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}>
                        <FaUserPlus className="mr-3" size={20} /> Admissions
                    </NavLink>
                    <NavLink to="/admin/manage-students" className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}>
                        <FaUsers className="mr-3" size={20} /> Students DB
                    </NavLink>
                    <NavLink to="/admin/manage-banners" className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}>
                        <FaUsers className="mr-3" size={20} /> Manage Banners
                    </NavLink>
                    <NavLink
                        to="/admin/manage-feedback"
                        className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}
                    >
                        <FaCommentDots className="mr-3" size={20} />
                        Manage Feedback
                    </NavLink>
                    <NavLink to="/admin/manage-student-art" className={({ isActive }) => `${linkClasses} ${isActive ? activeLinkClasses : ''}`}>
                        <FaPalette className="mr-3" size={20} /> Student Art
                    </NavLink>

                </nav>
            </aside>
        </>
    );
};

export default AdminSidebar;